import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  switch(event) {
    const color = event.currentTarget.dataset.color;
    this.changeTheme(color);
  }

  changeTheme(color) {
    document.documentElement.setAttribute("data-user-theme", color);

    fetch("/users.json", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector(`meta[name="csrf-token"]`)
          .content,
      },
      body: JSON.stringify({ user: { color_scheme: color } }),
    });
  }
}
